export default "__VITE_ASSET__D9cb17VN__"